import API_BASE_URL from '../../config';
import React, { useState, useEffect } from 'react';
import { Menu, Button } from 'semantic-ui-react';
import { useLocation } from "react-router-dom";

const Header = () => {
  const [promptEvent, setPromptEvent] = useState(null);
  const [appAccepted, setAppAccepted] = useState(false);
  const [companyLogoUrl, setCompanyLogoUrl] = useState(null);
  const location = useLocation();
  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const company = query.get("company");
    const token = query.get("token");
  
    if (!company) return;
    fetch(`${API_BASE_URL}/api/company-logo/?company=${company}&token=${token}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.logo_url) {
          setCompanyLogoUrl(data.logo_url);
        }
      })
      .catch((err) => console.error("Logo fetch error:", err));
  }, [location.search]);
  
  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setPromptEvent(e);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const isAppInstalled =
    window.matchMedia('(display-mode: standalone)').matches || appAccepted;

  const installApp = () => {
    if (!promptEvent) return;

    promptEvent.prompt();
    promptEvent.userChoice.then((result) => {
      if (result.outcome === 'accepted') {
        setAppAccepted(true);
        console.log('✅ Kullanıcı uygulamayı yüklemeyi kabul etti.');
      } else {
        console.log('❌ Kullanıcı yüklemeyi reddetti.');
      }
    });
  };

  return (
<Menu
  stackable
  style={{
    background: 'linear-gradient(90deg, #0f2027, #203a43, #2c5364)', // koyu ama şık
    border: 'none',
    boxShadow: '0 2px 5px rgba(0,0,0,0.4)',
  }}
>

<Menu.Item header style={{ padding: '0.5rem 1rem' }}>
  <a href="/">
    <img
      src="/logo.jpg"
      alt="Logo"
      style={{
        height: '80px',
        width: '80px',
        objectFit: 'cover',
        display: 'block',
        margin: '0 auto',
        borderRadius: '20%',
        border: '2px solid white',
        boxShadow: '0 0 10px rgba(0,0,0,0.3)'
      }}
    />
  </a>
</Menu.Item>

  <Menu.Item
    style={{
      flex: 1,
      justifyContent: 'center',
      display: 'flex',
      alignItems: 'center',
    }}
  >
    <span style={{ fontSize: '4rem', fontWeight: 'bold' , color: 'white' }}>
      Quders Danışmanlık ve Eğitim
    </span>
  </Menu.Item>


  <Menu.Item header style={{ padding: '0.5rem 1rem' }}>
  <a href="/">
    {companyLogoUrl && (
      <img
        src={companyLogoUrl}
        alt="Logo"
        style={{
          height: '80px',
          width: '80px',
          objectFit: 'cover',
          display: 'block',
          margin: '0 auto',
          borderRadius: '20%',
          border: '2px solid white',
          boxShadow: '0 0 10px rgba(0,0,0,0.3)'
        }}
      />
    )}
  </a>
</Menu.Item>


  {promptEvent && !isAppInstalled && (
    <Menu.Item position="right">
      <Button
        color="teal"
        icon="download"
        labelPosition="left"
        content="Install App"
        onClick={installApp}
      />
    </Menu.Item>
  )}
</Menu>

  );
};

export default Header;
